import React, { Component } from "react"
import { Link } from "gatsby"
import Moment from "react-moment"
import BlogLoader from "./../common/blogLoader"
import { getBlogListing } from "./../../services/blogListingService"

class BlogListingSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blogsList: [],
      loading: true,
    }
  }

  async componentDidMount() {
    const { data: blogsList } = await getBlogListing()
    this.setState({ blogsList, loading: false })
  }

  render() {
    const { blogsList, loading } = this.state

    console.log("Blog List: ", blogsList)

    if (loading) return <BlogLoader />
    return (
      <section id="blog-listing-section">
        <div className="container">
          <div className="row">
            {blogsList.map(blog => (
              <div className="col-lg-4 col-md-4 mt-5" key={blog.id}>
                <div className="blog-list-item">
                  <Link className="blog-link" to={"/blog-post/" + blog.slug}>
                    <figure className="m-0">
                      <div
                        className="blog-feature-img-size"
                        style={{ background: `url(${blog.media.large})` }}
                      />
                    </figure>
                  </Link>

                  <div className="blog-content">
                    <Link className="blog-link" to={"/blog-post/" + blog.slug}>
                      <h1 className="pt-3 pb-3 blog-title">{blog.title}</h1>
                    </Link>
                    <ul className="post-meta">
                      <li className="post-publish-date">
                        <i className="fa fa-calendar" aria-hidden="true" />
                        <span>
                          {" "}
                          <Moment format="DD-MM-YYYY">{blog.date}</Moment>
                        </span>
                      </li>
                      <li className="post-author">
                        <i className="fa fa-user" />
                        <span> {blog.author}</span>
                      </li>
                    </ul>

                    <div
                      className="blog-excerpt mb-3"
                      dangerouslySetInnerHTML={{ __html: blog.excerpt }}
                    />

                    <Link
                      className="read-more-blog-link"
                      to={"/blog-post/" + blog.slug}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default BlogListingSection
